import { Locale, K } from "../constants";

const locale: Locale = {
  [K.COPY_TOOLTIP]: "Copy",
  [K.EXPORT_TOOLTIP]: "Download",
  [K.EXPAND]: "Expand",
  [K.COLLAPSE]: "Collapse",
  [K.COPY_SUCCESS]: "Copy successfully",
  [K.COPY_ERROR]: "Copy failed",
};

export default locale;
